module.exports = __webpack_public_path__ + "img/cryptocurrency-01.682ed1e4.svg";